import Keyword from '@/models/keyword';
import axios from 'axios';

export class KeywordsController {
    /**
     * Get the available list of keywords
     *
     * @param void
     * @returns {Array|Error} An array of keyword models or an error object
     */
    static async index() {
        let response = axios
            .get('keywords')
            .then((resp) => resp.data.map((keyword) => new Keyword(keyword)))
            .catch((error) => Promise.reject(error))
        return await response
    }
    
    /**
     * Create a keyword model
     *
     * @param void
     * @returns {Keyword|Error} An keyword model or an error object
     */
    static async store($keyword) {
        let response = axios
            .post('keywords', $keyword)
            .then((resp) => new Keyword(resp.data))
            .catch((error) => Promise.reject(error))
        return await response
    }
}